import { render } from "./WildBookObserveAnimal.vue?vue&type=template&id=7274c142&scoped=true&ts=true"
import script from "./WildBookObserveAnimal.vue?vue&type=script&lang=ts"
export * from "./WildBookObserveAnimal.vue?vue&type=script&lang=ts"

import "./WildBookObserveAnimal.vue?vue&type=style&index=0&id=7274c142&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\eFJ\\eFjApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7274c142"]])

export default __exports__